import { Inject, Injectable } from '@angular/core';

import type { ApiClient } from '@packages/shared-utils';
import { API_CLIENT } from './api-client.provider';
import type { ApiConversation, ListMessagesResponse } from './api.types';

@Injectable({ providedIn: 'root' })
export class ConversationsApiService {
  constructor(@Inject(API_CLIENT) private readonly api: ApiClient) {}

  getConversation(conversationId: string): Promise<ApiConversation> {
    return this.api.get<ApiConversation>(`/conversations/${encodeURIComponent(conversationId)}`);
  }

  listMessages(
    conversationId: string,
    params?: { limit?: number; before?: string; after?: string },
  ): Promise<ListMessagesResponse> {
    const limit = params?.limit ?? 50;
    const before = params?.before ? `&before=${encodeURIComponent(params.before)}` : '';
    const after = params?.after ? `&after=${encodeURIComponent(params.after)}` : '';
    return this.api.get<ListMessagesResponse>(
      `/conversations/${encodeURIComponent(conversationId)}/messages?limit=${encodeURIComponent(String(limit))}${before}${after}`,
    );
  }

  muteConversation(
    conversationId: string,
    action: '15' | '30' | 'block',
  ): Promise<{ ok: true; mutedUntil: string | null; isBlocked: boolean }> {
    return this.api.post<{ ok: true; mutedUntil: string | null; isBlocked: boolean }>(
      `/conversations/${encodeURIComponent(conversationId)}/mute`,
      { action },
    );
  }

  returnToAi(conversationId: string): Promise<{ ok: true; conversationId: string }> {
    return this.api.post<{ ok: true; conversationId: string }>(
      `/conversations/${encodeURIComponent(conversationId)}/return-to-ai`,
      {},
    );
  }
}
